import * as React from 'react';
import { Outlet, type RouteObject } from 'react-router-dom';
import { createStaticHandler } from 'react-router';
import App from './App';
import IntlProvider from './i18n/IntlProvider';
import { AntdLocaleProvider } from './components/AntdLocaleProvider';
import { NavigationSetter } from './components/NavigationSetter';
import { PwaMobileNavProvider } from './utils/usePwaMobileNavEnabled';
import { appRouteObjects } from './routing/appRoutes';

const RootProviders: React.FC = () => (
  <>
    <NavigationSetter />
    <IntlProvider>
      <AntdLocaleProvider>
        <PwaMobileNavProvider>
          <Outlet />
        </PwaMobileNavProvider>
      </AntdLocaleProvider>
    </IntlProvider>
  </>
);

/** Shared route table for browser and SSR static routers. */
export const rootRouteObjects: RouteObject[] = [
  {
    element: <RootProviders />,
    children: [
      {
        element: <App />,
        children: appRouteObjects,
      },
    ],
  },
];

export const staticHandler = createStaticHandler(rootRouteObjects);
